import type { FC} from 'react';
import { memo } from 'react';
import { FormProvider } from 'react-hook-form';

import cn from 'classnames';

import { Blank, ModalLarge } from 'library/components/common';
import { ButtonAddBlock } from 'library/components/events';

import { Address, AddressCard } from './frames';

import { useAddressForm } from '../../model';
import * as st from './styles.module.scss';

interface Props {
	isOpen: boolean;
	close: () => void;
}

export const ModalAddress: FC<Props> = memo(({ isOpen, close }) => {
	const {
		onSubmit,
		addresses,
		deleteAddress,
		methods,
		resetFields,
		openFormAddress,
		openForm,
		isLoading,
	} = useAddressForm();
	return (
		<ModalLarge title={'Настройка адреса'} isOpen={isOpen} close={close} onRequestClose={close}>
			<div className={st.wrapper}>
				{openForm && (
					<section className={st.wrapper__form}>
						<FormProvider {...methods}>
							<form onSubmit={methods.handleSubmit(onSubmit)}>
								<div className={st.title}>
									<h3>Добавить адрес</h3>
									<div className={st.btn}>
										<button type="submit" disabled={isLoading}>
											Готово
										</button>
									</div>
								</div>
								<div className={st.form}>
									<Address isDisabled={isLoading} handler={resetFields} />
								</div>
							</form>
						</FormProvider>
					</section>
				)}

				<section className={st.wrapper__list}>
					<div className={st.title}>
						<h3>Текущие адреса</h3>
						<div className={cn(st.button, openForm && st.rotate)}>
							<ButtonAddBlock handler={openFormAddress} />
						</div>
					</div>

					<div className={st.list}>
						{!addresses.length ? (
							<div className={st.helper}>
								<Blank text={'Нет адресов'} />
							</div>
						) : (
							addresses.map((item, index) => (
								<AddressCard
									address={item}
									index={index}
									handler={deleteAddress}
									key={item.id}
									isDisabled={isLoading}
								/>
							))
						)}
					</div>
				</section>
			</div>
		</ModalLarge>
	);
});
